/* @flow */
import React from 'react';
import Button from 'components/Button.jsx';
import Link from 'components/Link.jsx';
import Text from 'components/Text.jsx';
import Glyph from 'components/Glyph.jsx';
import QuickPromotion from 'entities/QuickPromotion';
import { ImageTypes } from 'constants/QuickPromotionConstants.js';
import Image from 'components/Image.jsx';
import cx from 'classnames';

import './styles/ClassNavigationPromotion.scss';

export default class ClassNavigationPromotion extends React.Component {
  props: {
    promotion: QuickPromotion,
    onConfirm: Function,
    onCancel: Function,
  };

  renderImage() {
    const { promotion } = this.props;
    // const imageType = promotion.getImageType();
    const imageType = ImageTypes.RIGHT_ICON;

    if (![ImageTypes.RIGHT_ICON, ImageTypes.LEFT_ICON].includes(imageType)) {
      return null;
    }

    const className = {
      [ImageTypes.RIGHT_ICON]: 'ClassNavigationPromotion-image-right',
      [ImageTypes.LEFT_ICON]: 'ClassNavigationPromotion-image-left',
    }[imageType];

    return (
      <Image
        className={cx('ClassNavigationPromotion-image', className)}
        src={promotion.getImageUrl()}
      />
    );
  }

  render() {
    const { promotion } = this.props;
    const imageType = promotion.getImageType();
    return (
      <div className="ClassNavigationPromotion">
        <div className="ClassNavigationPromotion-header">
          <span>
            <Text size="xxxsmall" color="pitch">
              {promotion.getHeader()}
            </Text>
            {imageType === ImageTypes.RIGHT_ICON ? this.renderImage() : this.renderImage()}
            <Button
              color="koala"
              level="text"
              className="ClassNavigationPromotion-close"
              onClick={this.props.onCancel}
              eventElementName="ClassNavigationPromotion-close">
              <Glyph name="close" size="xsmall" />
            </Button>
          </span>
        </div>

        <Text element="div" color="thunder" size="xxxsmall">
          {promotion.getBody()}
          <Link onClick={this.props.onConfirm}>
            {' '} {promotion.getPrimaryAction().getLabel()}
          </Link>
        </Text>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/groups/components/ClassNavigationPromotion.jsx